import { render } from "./GreenCatIcon.svg?vue&type=template&id=65505ac4"
const script = {}
script.render = render

export default script